export default __webpack_public_path__ + "static/media/WStore_All.98d0b1e9.png";